import styles from "./topbar.module.css";

const Topbar = () => {
  return (
    <div className={styles.head}>
      <p>Calendar App</p>
    </div>
  );
};

export default Topbar;
